function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoFooterW = function SvgLogoFooterW(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 128.29 72"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26.57 72h10.28V46.67H26.57Zm43-25.33-4.92 12h-1l-4.92-12h-10.4L58.88 72h10.46l10.55-25.33Zm21.83 0V72h10.28V46.67Zm10.28 0h26.57v-8.74h-26.6ZM26.57 0v37.93H0v8.74h26.57v-8.74h10.28V21.6h1l6.8 16.33h10.44L39.52 0ZM88.7 0 73.12 37.93h10.41l6.81-16.33h1v16.33h10.28V0Z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgLogoFooterW;